module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-block', {
    staticClass: "home-dentists",
    attrs: {
      "block": "light"
    }
  }, [_c('div', {
    staticClass: "home-dentists__inner group group--first-last"
  }, [_c('div', {
    class: [
      "home-dentists__image",
      ("home-dentists__image--" + (_vm.animationClass ? "open" : "closed")) ]
  }, [_c('div', {
    staticClass: "home-dentists__image-wrapper"
  }, _vm._l((_vm.images.pages), function(image, index) {
    return _c('img', {
      key: index,
      class: [
        "home-dentists__paper",
        ("home-dentists__paper--" + index) ],
      attrs: {
        "src": image
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "home-dentists__content"
  }, [_c('h2', {
    staticClass: "h3 mt0 home-dentists__heading"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _vm._l((_vm.copy), function(p, index) {
    return _c('p', {
      key: index,
      staticClass: "p",
      domProps: {
        "innerHTML": _vm._s(p)
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "home-dentists__form"
  }, [_c('module-form', {
    attrs: {
      "form-id": "register-dentist",
      "fields": {
        dentistEmail: {
          type: "email",
          label: "Email",
          labelHidden: true,
          placeholder: "Enter Your Email",
        },
      },
      "button": "primary",
      "submit": "Sign up now",
      "action": _vm.action,
      "success": _vm.success,
      "fail": _vm.fail
    }
  })], 1)], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bda401e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/home/Dentists.vue
// module id = 244
// module chunks = 0